import "./multiPanelCards.css";
import { useState } from "react";

export default function MultiPanelCards({ headerText, freeButtonText, freeButtonLink, buttons }) {
  // Initialize activeTab from the passed buttons array.
  const [activeTab, setActiveTab] = useState(buttons[0]);

  // Function to handle the free button click
  const handleFreeButtonClick = () => {
    window.open(freeButtonLink, "_blank");
  };

  return (
    <div className="org-card-container">
      <div className="org-card-header-container">
        <div className="org-card-header">{headerText}</div>
      </div>

      <div className="org-card-button-group">
        {buttons.map((button, index) => (
          <button
            className={`org-card-button ${activeTab.title === button.title ? "org-active" : ""}`}
            key={index}
            onClick={() => setActiveTab(button)}
          >
            {button.title}
          </button>
        ))}
      </div>

      <div className="org-card-content">
        <div className="org-card-content-info">
          <div className="org-card-info-header-container">
            <div className="org-card-info-header">{activeTab.title}</div>
            <div className="org-card-info-subtext">{activeTab.subtext}</div>
          </div>
          <button className="org-card-free-button" onClick={handleFreeButtonClick}>
            {freeButtonText}
          </button>
        </div>

        <div className="org-card-content-image">
          <img src={activeTab.image} className="org-card-image" alt="" />
        </div>
      </div>
    </div>
  );
}
